import { call, put, takeLatest, delay, select } from "redux-saga/effects"
import {
	GET_USER_MANAGEMENT_LIST,
	POST_CREATE_USER_REQUEST,
	DELETE_USER_REQUEST,
	EMAIL_AVAILABILITY_CHECK,
	UPDATE_USER_REQUEST,
	GET_CASE_ACCESS_LIST,
} from "../types"
import {
	getUsersListSuccess,
	getUsersListFailed,
	createUserSuccess,
	createUserFailed,
	deleteUserSuccess,
	deleteUserFailed,
	emailAvailabilityCheckSuccess,
	emailAvailabilityCheckFailed,
	updateUserSuccess,
	updateUserFailed,
	getCaseAccessListFailed,
	getCaseAccessListSuccess,
} from "../actions/usersActions"
import { usersService } from "../services/users.services"
import { setNotification } from "../actions/notificationActions"

function* getUsersListSaga(action) {
	try {
		const result = yield call(usersService.getUsersListApi, action.payload)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(getUsersListSuccess(result?.data?.users))
		} else {
			yield put(getUsersListFailed(result))
		}
	} catch (error) {
		yield put(getUsersListFailed(error))
	}
}

function* createUserSaga(action) {
	try {
		const result = yield call(usersService.createUserAPI, action.payload)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(createUserSuccess(result?.data?.users))
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "success",
				})
			)
		} else {
			yield put(createUserFailed(result))
			yield put(
				setNotification({
					data: result?.data?.message || "There was an error. Please, try again and check your connection",
					severity: "error",
				})
			)
		}
	} catch (error) {
		yield put(createUserFailed(error))
	}
}

function* deleteUserSaga(action) {
	try {
		const result = yield call(usersService.deleteUserAPI, action.payload)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(deleteUserSuccess({}))
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "success",
				})
			)
		} else {
			yield put(deleteUserFailed(result))
			yield put(
				setNotification({
					data: result?.data?.message || "There was an error. Please, try again and check your connection",
					severity: "error",
				})
			)
		}
	} catch (error) {
		yield put(deleteUserFailed(error))
	}
}

function* checkEmailAvailabilitySaga(action) {
	try {
		const result = yield call(usersService.checkEmailAvailabilityAPI, action.payload)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(emailAvailabilityCheckSuccess(result?.data))
		} else {
			yield put(emailAvailabilityCheckFailed(result))
		}
	} catch (error) {
		yield put(emailAvailabilityCheckFailed(error))
	}
}

function* updateUserSaga(action) {
	try {
		const result = yield call(usersService.updateUserAPI, action.payload)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(updateUserSuccess(result?.data?.user))
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "success",
				})
			)
		} else {
			yield put(updateUserFailed(result))
			yield put(
				setNotification({
					data: result?.data?.message || "There was an error. Please, try again and check your connection",
					severity: "error",
				})
			)
		}
	} catch (error) {
		yield put(updateUserFailed(error))
	}
}

function* getCaseListSaga(action) {
	try {
		const result = yield call(usersService?.getCaseListAPI, action.payload)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(getCaseAccessListSuccess(result?.data?.cases))
		} else {
			yield put(getCaseAccessListFailed({}))
			yield put(
				setNotification({
					data: result?.data?.message || "There was an error. Please, try again and check your connection",
					severity: "error",
				})
			)
		}
	} catch (error) {
		yield put(getCaseAccessListFailed({}))
	}
}

function* usersWatcher() {
	yield takeLatest(GET_USER_MANAGEMENT_LIST, getUsersListSaga)
	yield takeLatest(POST_CREATE_USER_REQUEST, createUserSaga)
	yield takeLatest(DELETE_USER_REQUEST, deleteUserSaga)
	yield takeLatest(EMAIL_AVAILABILITY_CHECK, checkEmailAvailabilitySaga)
	yield takeLatest(UPDATE_USER_REQUEST, updateUserSaga)
	yield takeLatest(GET_CASE_ACCESS_LIST, getCaseListSaga)
}

export default usersWatcher
